import SERVER_ACTION_TYPES from './server-action-types.json';
import CLIENT_ACTION_TYPES from './client-action-types.json';

export const ACTION_TYPES_MAP = { ...SERVER_ACTION_TYPES, ...CLIENT_ACTION_TYPES };
